 
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18next from "i18next";

i18next
  .use(LanguageDetector) // Detect language from browser/localStorage
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: require("./locales/en.json") },
      fr: { translation: require("./locales/fr.json") },
      ar: { translation: require("./locales/ar.json") },
    },
    fallbackLng: "en", // default language
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18next;
